import React from 'react';

import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react';

import SummaryCard from 'components/SummaryCard';

type ProgressMetric = {
  label: string;
  value?: number;
};

interface ProgressMetricsCardsProps extends SimpleGridProps {
  metrics: ProgressMetric[];
}

const formatValue = (value?: number): string => {
  return Intl.NumberFormat('pt-BR').format(value ?? 0);
};

const ProgressMetricsCards: React.FC<ProgressMetricsCardsProps> = ({
  metrics,
  ...restProps
}) => {
  return (
    <SimpleGrid
      columns={{ base: 1, md: metrics.length }}
      spacing={{ base: 4, md: 6 }}
      {...restProps}
    >
      {metrics.map((metric, idx) => (
        <SummaryCard
          key={metric.label}
          idx={idx}
          isHidden={false}
          unsetWidth
          width="100%"
          typeNumber="number"
          data={{
            title: metric.label,
            number: metric.value ?? 0,
            formattedNumber: formatValue(metric.value),
            colorSchemeType: 'chakra',
            colorSchemeCard: 'brand',
          }}
        />
      ))}
    </SimpleGrid>
  );
};

export default ProgressMetricsCards;
